import { DevLanguageSwitcher, displayLanguageSwitcher, ResetSitecoreStyles } from '@hex/calculators-shared/components';
import { defaultTheme, SapphireProvider } from '@sapphire-react/core';
import { InterestRateCalculator } from './InterestRateCalculator';

export function App() {
  return (
    <ResetSitecoreStyles>
      <span
        style={{ display: 'none' }}
        data-build-id={import.meta.env.NX_PUBLIC_BUILD_NUMBER}
        data-git-hash={import.meta.env.NX_PUBLIC_GIT_HASH}
      />
      <SapphireProvider theme={defaultTheme} locale={'sv-SE'} width={'100%'}>
        {displayLanguageSwitcher && <DevLanguageSwitcher languages={['se']} />}
        <InterestRateCalculator />
      </SapphireProvider>
    </ResetSitecoreStyles>
  );
}
